import React, { useState } from "react";
import { useParams, useHistory } from "react-router";
import { useData } from "../../../components/firebase/DataProvider";
import Gap from "../../../components/Gap";
import Header from "../../../components/molecules/Header";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import useStyle from "./style";
import BelumBayar from "./belumBayar";
import DiKirim from "./diKirim";
import DiProsess from "./diProsess";
import DiTerima from "./diTerima";
import SudahBayar from "./sudahBayar";
import DiBatalkan from "./diBatalkan";
import PreOrder from "./preOrder";

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

function TransaksiList() {
  const classes = useStyle();
  const history = useHistory();
  const { preorderUtils } = useData();
  const { mode, title } = useParams();

  const [tabValue, setTabValue] = useState("not-paid");
  const [tabs, setTabs] = useState([
    {
      label: "Belum Bayar",
      value: "not-paid",
      active: true,
    },
    {
      label: "Pre Order",
      value: "preorder",
      active: preorderUtils?.down_payment_option && mode ==="sellerapp",
    },
    {
      label: "Sudah Bayar",
      value: "paid",
      active: true,
    },
    {
      label: "Diproses",
      value: "processed",
      active: true,
    },
    {
      label: "Dikirim",
      value: "sent",
      active: true,
    },
    {
      label: "Diterima",
      value: "received",
      active: true,
    },
    {
      label: "Dibatalkan",
      value: "canceled",
      active: true,
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };


  return (
    <>
      <Header
        type="with-title"
        title={`Transaksi Via ${title}`}
        onClick={() => history.push("/transaksi")}
      />
      <Gap height={60} />
      <Paper square variant="outlined">
        <Tabs
          variant="scrollable"
          scrollButtons="on"
          textColor="primary"
          indicatorColor="primary"
          value={tabValue || "not-paid"}
          onChange={handleChange}
          aria-label="scrollable force tabs example"
        >
          {tabs.map(
            (tab) =>
              tab.active && (
                <Tab
                  className={classes.tab}
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  {...a11yProps(tab.value)}
                />
              )
          )}
        </Tabs>
        <BelumBayar modes={mode} value={tabValue} />
        <PreOrder modes={mode} value={tabValue} />
        <DiKirim modes={mode} value={tabValue} />
        <DiProsess modes={mode} value={tabValue} />
        <DiTerima modes={mode} value={tabValue} />
        <SudahBayar modes={mode} value={tabValue} />
        <DiBatalkan modes={mode} value={tabValue} />
      </Paper>
    </>
  );
}

export default TransaksiList;
